/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHealthCamp } from 'app/shared/model/health-camp.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface IHealthCampRegistration {
  id?: string;
  registrationDate?: number;
  organizerType?: keyof typeof EntityType;
  organizerId?: string;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  camp?: IHealthCamp | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IHealthCampRegistration> = {
  active: false,
};
